import addScriptTag from './../add-script'
import axios from 'axios'

export default class AbstractProvider {

    constructor(media) {
        this.player = null
        this.media = media
        this.media.embed = media.embed || ''
        this.media.embedId = 'media-embed-' + this.media.id
        this.media.provider = () => this
        this.setEmbedCode()
        addScriptTag(this.script())
    }

    initPlayer(player) {
        this.player = player

        return this
    }

    pause() {
        this.player.pause()
    }

    script() {
        return null
    }

    handleOembedResponse(response) {
        this.media.embed = response.data.html
    }

    oembed(url) {
        axios.get(url, {
            params: {
                url: this.media.url,
                format: 'json',
                color: this.media.color,
            },
        }).then(response => this.handleOembedResponse(response))
    }

}